import React, { useEffect } from "react";

const SocialMediaEmbed = ({ platform, embed }) => {
  useEffect(() => {
    if (platform === "Instagram") {
      const script = document.createElement("script");
      script.async = true;
      script.defer = true;
      script.src = "https://www.instagram.com/embed.js";
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }

    if (platform === "Twitter (X)") {
      const script = document.createElement("script");
      script.src = "https://platform.twitter.com/widgets.js";
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [platform]);

  return (
    <div
      className="social-media-embed flex items-center justify-center w-full"
      dangerouslySetInnerHTML={{ __html: embed }}
    />
  );
};

export default SocialMediaEmbed;
